import { useState, useEffect } from 'react';

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    // Cleanup function to remove the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty dependency array ensures this effect runs only once on mount and unmount

  return windowSize;
};

export const isTooSmall = (width) => {
    console.log(width);
    return width < 1024;
}

export const hslToHex = (h, s, l) => {
  s /= 100; l /= 100;
  const k = n => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = n => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  const toHex = x => Math.round(255 * x).toString(16).padStart(2, '0');
  return `#${toHex(f(0))}${toHex(f(8))}${toHex(f(4))}`;
};

export const randomDarkBlueHex = () => {
  const hue = 210 + Math.random() * 30;    // 210–240 (blue range)
  const sat = 60 + Math.random() * 25;     // 60–85% saturation
  const light = 20 + Math.random() * 25;   // 20–45% lightness (dark/moderate)
  return hslToHex(hue, sat, light);
};

export const randomDarkGreenHex = () => {
  // Hue for green ≈ 100–140 degrees
  const hue = 100 + Math.random() * 40;
  const saturation = 50 + Math.random() * 40; // keep it fairly saturated
  const lightness = 20 + Math.random() * 20;  // 20–40% = dark tones

  return hslToHex(hue, saturation, lightness);
};